export const AuthTypes = {
    LOGIN_AUTH : 'AUTH_LOGIN_AUTH',
    LOGOUT_AUTH : 'AUTH_LOGOUT_AUTH',
    AUTH_SET_OWNERSHIP : 'AUTH_SET_OWNERSHIP_AUTH',
};